import { render, staticRenderFns } from "./organization-duplicate-option-modal.vue?vue&type=template&id=da2be21c"
import script from "./organization-duplicate-option-modal.vue?vue&type=script&lang=js"
export * from "./organization-duplicate-option-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports